type CreateUnavailabilityError = {
  emptyName: boolean;
  invalidDateRange: boolean;
  invalidStartDate: boolean;
  invalidUnavailabilityDates: boolean;
  invalidUnavailabilityNonWorkedHoursCount: boolean;
  invalidResource: boolean;
  invalidReason: boolean;
};

const createUnavailabilityError: CreateUnavailabilityError = {
  emptyName: false,
  invalidDateRange: false,
  invalidStartDate: false,
  invalidUnavailabilityDates: false,
  invalidUnavailabilityNonWorkedHoursCount: false,
  invalidResource: false,
  invalidReason: false,
};

export type { CreateUnavailabilityError };

export { createUnavailabilityError };
